export const taxableValues = [
  {
    value: 'yes',
    label: 'Yes',
  },
  {
    value: 'no',
    label: 'No',
  },
  {
    value: 'flexi',
    label: 'Flexi',
  },
] as const;

export type TaxableValue = typeof taxableValues[number]['value'];
export interface SalaryStructureComponent {
  id: string;
  name: string;
  isNameEditable: boolean;
  taxable: TaxableValue;
  isTaxableEditable: boolean;
  isRemovable: boolean;
  amount: string;
  type: 'default' | 'customAllowance';
}

export const componentNames = {
  basic: 'Basic Salary',
  da: 'Dearness Allowance',
  hra: 'HRA',
  sa: 'Special Allowance',
  lta: 'LTA',
  esi: 'Employer ESI Contribution',
  pf: 'Employer PF Contribution',
  nps: 'Employer NPS Contribution',
  lwf: 'LWF Employer Contribution',
};

const npsSalaryStructureComponent: SalaryStructureComponent = {
  id: 'nps',
  name: componentNames.nps,
  isNameEditable: false,
  taxable: 'no',
  isTaxableEditable: false,
  isRemovable: true,
  amount: '0',
  type: 'default',
};

export const customSalaryStructureDefaultComponentsWithoutNps: SalaryStructureComponent[] = [
  {
    id: 'basic',
    name: componentNames.basic,
    isNameEditable: false,
    taxable: 'yes',
    isTaxableEditable: false,
    isRemovable: false,
    amount: '0',
    type: 'default',
  },
  {
    id: 'da',
    name: componentNames.da,
    isNameEditable: false,
    taxable: 'yes',
    isTaxableEditable: false,
    isRemovable: false,
    amount: '0',
    type: 'default',
  },
  {
    id: 'hra',
    name: componentNames.hra,
    isNameEditable: false,
    taxable: 'yes',
    isTaxableEditable: false,
    isRemovable: false,
    amount: '0',
    type: 'default',
  },
  {
    id: 'sa',
    name: componentNames.sa,
    isNameEditable: false,
    taxable: 'yes',
    isTaxableEditable: false,
    isRemovable: false,
    amount: '0',
    type: 'default',
  },
  {
    id: 'lta',
    name: componentNames.lta,
    isNameEditable: false,
    taxable: 'yes',
    isTaxableEditable: false,
    isRemovable: false,
    amount: '0',
    type: 'default',
  },
  {
    id: 'esi',
    name: componentNames.esi,
    isNameEditable: false,
    taxable: 'no',
    isTaxableEditable: false,
    isRemovable: true,
    amount: '0',
    type: 'default',
  },
  {
    id: 'pf',
    name: componentNames.pf,
    isNameEditable: false,
    taxable: 'no',
    isTaxableEditable: false,
    isRemovable: true,
    amount: '0',
    type: 'default',
  },
];

export const customSalaryStructureDefaultComponentsWithNps: SalaryStructureComponent[] = [
  ...customSalaryStructureDefaultComponentsWithoutNps,
  npsSalaryStructureComponent,
];
